module.exports = __webpack_public_path__ + "static/media/line.e22f79b9.jpg";